let analyticsInstance = null;
export const setAnalyticsProvider = (instance) => {
    if (!instance || analyticsInstance)
        return;
    analyticsInstance = instance;
};
export const getAnalyticsProvider = () => {
    return analyticsInstance;
};
